import vars from 'vars'

let navData = {
	'lv1': 0,
	'navlist': [
		// {
		// 	'name': '首页',
		// 	'rel': 'home',
		// 	'link': vars.index,
		// 	'children': {
		// 		'activeindex': 0,
		// 		'list': []
		// 	}
		// },
		{
			'name': '课程',
			'rel': 'course',
            'key': 'nav.course',
			'link': vars.course,
			'children': {
				'activeindex': 0,
				'list': [
					{
						'name': '班级课程',
						'rel': 'normalcourse'
					},
					{
						'name': '公开课',
						'rel': 'opencourse'
					}
				]
			}
		},
		{
			'name': '发现',
			'rel': 'discover',
            'key': 'nav.discover',
			'link': vars.discover,
			'children': {
				'activeindex': 0,
				'list': []
			}
		},
		{
			'name': '消息',
			'rel': 'message',
            'key': 'nav.message',
			'link': vars.message,
			'children': {
				'activeindex': 0,
				'list': []
			}
		}
		// {
		// 	'name': '我',
		// 	'rel': 'myself',
		// 	'link': vars.myself,
		// 	'children': {
		// 		'list': []
		// 	}
		// }
	]
}

if(vars.hideOpencourse){
	navData = {
		'lv1': 0,
		'navlist': [
			{
				'name': '课程',
				'rel': 'course',
				'link': vars.course,
				'children': {
					'activeindex': 0,
					'list': [
						{
							'name': '班级课程',
							'rel': 'normalcourse'
						},
						{
							'name': '公开课',
							'rel': 'opencourse'
						}
					]
				}
			}
		]
	}
}

export default navData



// WEBPACK FOOTER //
// ./src/util/nav-data.js